import { Box } from '@wix/design-system';
import { isInteractiveClickTarget } from '@wix/domains-search-suite';
import React from 'react';
import { useIsRecommendationsListActive } from '../Recommendations/RecommendationsListActivity';
import { BrokerDescription } from './BrokerDescription';
import { BrokerDomainTitle } from './BrokerDomainTitle';
import { BrokerFeePrice } from './BrokerFeePrice';
import { BrokerTakenBadge } from './BrokerTakenBadge';
import { HireBrokerButton } from './HireBrokerButton';
import { SearchedDomainBrokerDataHooks } from './dataHooks';
import { useHireBroker } from './useHireBroker';
import s from './BrokerCard.css';
export const BrokerCard = _ref => {
  let domainName = _ref.domainName;
  const hireBroker = useHireBroker(domainName);
  const isActive = !useIsRecommendationsListActive();
  return /*#__PURE__*/React.createElement("div", {
    onClick: event => {
      if (!isInteractiveClickTarget(event.target)) {
        hireBroker();
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: [s.card, isActive && s.active].filter(Boolean).join(' '),
    borderRadius: "12px",
    padding: "20px 24px",
    verticalAlign: "bottom",
    gap: "SP4",
    dataHook: SearchedDomainBrokerDataHooks.component
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "12px",
    flex: 1,
    minWidth: 0
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(BrokerTakenBadge, null)), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "4px"
  }, /*#__PURE__*/React.createElement(BrokerDomainTitle, {
    domainName: domainName
  }), /*#__PURE__*/React.createElement(BrokerDescription, {
    domainName: domainName
  }))), /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: "16px",
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(BrokerFeePrice, {
    align: "right"
  }), /*#__PURE__*/React.createElement(HireBrokerButton, {
    domainName: domainName
  }))));
};
//# sourceMappingURL=BrokerCard.js.map